export function KPI({ label, value, unit = "", trend, sub, tone = "default", testid }) {
  const toneCls = {
    default: "text-zinc-50",
    good: "text-emerald-400",
    warn: "text-amber-400",
    bad: "text-red-400",
  }[tone];
  return (
    <div data-testid={testid} className="bg-zinc-950 border border-zinc-900 rounded-md p-4 hover:border-zinc-800 transition-colors">
      <div className="text-[10px] uppercase tracking-[0.16em] text-zinc-500 font-mono">{label}</div>
      <div className={`mt-2 font-mono font-medium text-3xl ${toneCls}`}>{value}<span className="text-base text-zinc-500 ml-1">{unit}</span></div>
      {sub && <div className="text-xs text-zinc-500 mt-1">{sub}</div>}
      {trend && <div className={`text-[11px] mt-1 ${trend.startsWith("+") ? "text-emerald-500" : "text-red-500"}`}>{trend}</div>}
    </div>
  );
}

export function SeverityBadge({ level = "info", children, testid }) {
  const cls = {
    critical: "bg-red-500/10 text-red-400 border-red-500/30",
    high: "bg-orange-500/10 text-orange-400 border-orange-500/30",
    medium: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    low: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    info: "bg-blue-500/10 text-blue-400 border-blue-500/30",
    success: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  }[level] || "bg-zinc-800 text-zinc-300 border-zinc-700";
  return <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-mono font-medium uppercase tracking-wider border ${cls}`}>{children || level}</span>;
}

export function StatusBadge({ status }) {
  const map = {
    open: "bg-blue-500/10 text-blue-400 border-blue-500/30",
    in_progress: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    pending: "bg-zinc-700 text-zinc-300 border-zinc-600",
    closed: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    resolved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    maintenance: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    retired: "bg-zinc-700 text-zinc-300 border-zinc-600",
    investigating: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    success: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    warning: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    failed: "bg-red-500/10 text-red-400 border-red-500/30",
    online: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    offline: "bg-red-500/10 text-red-400 border-red-500/30",
    enabled: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    disabled: "bg-red-500/10 text-red-400 border-red-500/30",
  };
  const cls = map[status] || "bg-zinc-800 text-zinc-300 border-zinc-700";
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-mono font-medium uppercase tracking-wider border ${cls}`}>{status?.replaceAll("_", " ")}</span>;
}

export function RenewalChip({ daysLeft }) {
  let cls = "bg-zinc-900 text-zinc-400 border-zinc-800";
  let label = `${daysLeft}d`;
  if (daysLeft <= 30) cls = "bg-red-500/15 text-red-400 border-red-500/30";
  else if (daysLeft <= 60) cls = "bg-amber-500/15 text-amber-400 border-amber-500/30";
  else if (daysLeft <= 90) cls = "bg-blue-500/15 text-blue-400 border-blue-500/30";
  if (daysLeft < 0) { cls = "bg-red-700/30 text-red-300 border-red-600/40"; label = `${Math.abs(daysLeft)}d overdue`; }
  return <span className={`px-2 py-0.5 rounded-full text-[10px] font-mono font-medium border ${cls}`}>{label}</span>;
}

export function Ring({ value = 0, label = "", size = 72 }) {
  const r = (size - 12) / 2;
  const c = 2 * Math.PI * r;
  const v = Math.max(0, Math.min(100, value));
  const stroke = v >= 80 ? "#10B981" : v >= 50 ? "#F59E0B" : "#EF4444";
  return (
    <div className="flex flex-col items-center gap-1">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size/2} cy={size/2} r={r} stroke="#27272A" strokeWidth="6" fill="none" />
        <circle cx={size/2} cy={size/2} r={r} stroke={stroke} strokeWidth="6" fill="none" strokeDasharray={`${(v/100)*c} ${c}`} strokeLinecap="round" />
      </svg>
      <div className="-mt-12 mb-12 font-mono text-lg text-zinc-50">{Math.round(v)}<span className="text-xs text-zinc-500">%</span></div>
      {label && <div className="text-[10px] text-zinc-500 uppercase tracking-widest font-mono text-center">{label}</div>}
    </div>
  );
}
